var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GiVendorIndex',{attrs:{"pageTitle":"Good Issue (Vendor Warehouse)","useVendorWarehouseModal":true,"isCentralWarehouse":false,"includeCentralWarehouseParam":true}})}
var staticRenderFns = []

export { render, staticRenderFns }